module.exports = __webpack_public_path__ + "img/openbet.3653745.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/openbet.png
// module id = Pnja
// module chunks = 39 44